import { useState } from 'react';

const isBool = (val) => typeof val === 'boolean';

const useCheckboxProps = (setting, pudCfg) => {
  const { ReadOnly, DefaultOptIn } = pudCfg?.properties || {};

  const defaultVal = isBool(setting) ? setting : DefaultOptIn === 'true';
  const [checked, setChecked] = useState(defaultVal);

  const checkboxProps = {
    checked,
    disabled: ReadOnly === 'true',
    title: pudCfg?.verbiage?.Name,
    description: pudCfg?.verbiage?.Description,
  };

  return [checked, setChecked, checkboxProps];
};

export default useCheckboxProps;
